import { render, staticRenderFns } from "./processBodyFour.vue?vue&type=template&id=b5f1ac60&scoped=true"
import script from "./processBodyFour.vue?vue&type=script&lang=js"
export * from "./processBodyFour.vue?vue&type=script&lang=js"
import style0 from "./processBodyFour.vue?vue&type=style&index=0&id=b5f1ac60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f1ac60",
  null
  
)

export default component.exports